export const appStatusClassMixin = {
  methods: {
    appStatusClass: function (item) {
      if (item.appStatusCode === 'R') {
        return 'amber--text'
      } else if (item.appStatusCode === 'C') {
        return 'red--text'
      }
    }
  }
}
